/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ProfileRecordDialog.vue?vue&type=template&id=04f946ff&scoped=true"
import script from "./ProfileRecordDialog.vue?vue&type=script&lang=js"
export * from "./ProfileRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./ProfileRecordDialog.vue?vue&type=style&index=0&id=04f946ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f946ff",
  null
  
)

export default component.exports